import React from 'react';

import Page from 'components/page/Page';
import PageHeading from 'components/page/page-heading/PageHeading';
import HealthInfo from '../components/HealthInfo';

const HealthPage = () => (
  <Page
    documentTitle="Health Check"
  >
    <PageHeading
      heading="Health Check"
    />
    <HealthInfo />
  </Page>
);


export default HealthPage;
